require('./bootstrap');

var windowWidth = $(window).width();

function uncheckMenuToggler() {
    if (windowWidth <= 768) {
        $('#toggleMenu').prop( 'checked', true );
        $('#navbar-left').animate({marginLeft: '-180px'}, 300);
    }
}

function toggleMenu() {
    if($('#toggle-left').hasClass('inactive')) {$('#toggle-left').toggleClass('inactive');$('#toggle-left').toggleClass('active');} else {$('#toggle-left').toggleClass('active');$('#toggle-left').toggleClass('inactive');}
    if($('#toggle-right').hasClass('active')) {$('#toggle-right').toggleClass('active');$('#toggle-right').toggleClass('inactive');} else {$('#toggle-right').toggleClass('inactive');$('#toggle-right').toggleClass('active');}
    var toggleChecked = $('#toggleMenu').prop('checked');
    if(toggleChecked) {
        $('#navbar-left').animate({marginLeft: '0px'}, 300);
        if (windowWidth > 768) {
            $('#main-container').animate({marginLeft: '180px'}, 300);
        }
    } else {
        $('#navbar-left').animate({marginLeft: '-180px'}, 300);
        if (windowWidth > 768) {
            $('#main-container').animate({marginLeft: '0px'}, 300);
        }
    }
    var nextStatus;
    if(toggleChecked) nextStatus = false; else nextStatus = true;
    $('#toggleMenu').prop('checked', nextStatus);
}

const feather = require('feather-icons');
feather.replace();

$(window).on('load', function(){
    uncheckMenuToggler();
});

$(window).resize(function(){
    windowWidth = $(window).width();
    uncheckMenuToggler();
});

function delay(callback, ms) {
    var timer = 0;
    return function() {
        var context = this, args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            callback.apply(context, args);
        }, ms || 0);
    };
}

function validURL(str) {
    var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
        '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
    return !!pattern.test(str);
}

jQuery.validator.addMethod("phone", function (phone_number, element) {
    phone_number = phone_number.replace(/\s+/g, "");
    return this.optional(element) || phone_number.length >= 9 &&
        phone_number.match(/^[\s()+-]*([0-9][\s()+-]*){6,20}$/);
}, "Please specify a valid phone number");

jQuery.validator.addMethod("vatnumber", function (vat_number, element) {
    vat_number = vat_number.replace(/\s+/g, "");
    return this.optional(element) || vat_number.match(/^((AT)?U[0-9]{8}|(BE)?0[0-9]{9}|(BG)?[0-9]{9,10}|(CY)?[0-9]{8}(B|L)|(CZ)?[0-9]{8,10}|(DE)?[0-9]{9}|(DK)?[0-9]{8}|(EE)?[0-9]{9}|(EL|GR)?[0-9]{9}|(ES)?[0-9A-Z][0-9]{7}[0-9A-Z]|(FI)?[0-9]{8}|(FR)?[0-9A-Z]{2}[0-9]{9}|(GB)?([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3})|(HU)?[0-9]{8}|(IE)?[0-9]S[0-9]{5}L|(IT)?[0-9]{11}|(LT)?([0-9]{9}|[0-9]{12})|(LU)?[0-9]{8}|(LV)?[0-9]{11}|(MT)?[0-9]{8}|(NL)?[0-9]{9}B[0-9]{2}|(PL)?[0-9]{10}|(PT)?[0-9]{9}|(RO)?[0-9]{2,10}|(SE)?[0-9]{12}|(SI)?[0-9]{8}|(SK)?[0-9]{10})$/);
}, "Please specify a valid vat number");

jQuery.validator.addMethod("year", function (year, element) {
    year = year.replace(/\s+/g, "");
    return this.optional(element) || year.match(/^\d{4}$/);
}, "Please specify a valid year");

jQuery.validator.addMethod("iban", function (iban, element) {
    iban = iban.replace(/\s+/g, "");
    return this.optional(element) || iban.match(/^([A-Z]{2}[ \-]?[0-9]{2})(?=(?:[ \-]?[A-Z0-9]){9,30}$)((?:[ \-]?[A-Z0-9]{3,5}){2,7})([ \-]?[A-Z0-9]{1,3})?$/);
}, "Please specify a valid IBAN");

jQuery.validator.addMethod("swift", function (swift, element) {
    swift = swift.replace(/\s+/g, "");
    return this.optional(element) || swift.match(/^([a-zA-Z]){4}([a-zA-Z]){2}([0-9a-zA-Z]){2}([0-9a-zA-Z]{3})?$/);
}, "Please specify a valid SWIFT CODE");

jQuery.validator.addMethod("intrastat", function (intrastat, element) {
    intrastat = intrastat.replace(/\s+/g, "");
    return this.optional(element) || intrastat.match(/^\d{8}$/);
}, "Please specify a valid INTRASTAT CODE");

$(window).scroll(function() {
    var scrollTop = $(window).scrollTop();
    var gtranslateheight = $('.goog-te-banner-frame').height();
    if(scrollTop > 0) {
        $('.navbar').addClass('fixed');
        if(gtranslateheight != undefined) $('.navbar').css('margin-top', (gtranslateheight + 2) +'px');
        $('main').css('margin-top', '120px');
    } else {
        $('.navbar').removeClass('fixed');
        $('.navbar').css('margin-top', '0px');
        $('main').css('margin-top', '0px');
    }
});

$( document ).ready(function() {

    //console.log( "ready!" );

    $('.select2').select2({
        containerCssClass : "small",
        matcher: function(params, data) {
            var original_matcher = $.fn.select2.defaults.defaults.matcher;
            var result = original_matcher(params, data);
            if (result && data.children && result.children && data.children.length != result.children.length) {
                result.children = data.children;
            }
            return result;
        }
    });

    $('.select2tags').select2({
        tags: true,
        containerCssClass : "small"
    });

    // The search functions to View PZ As
    $('#user_id').select2({
        matcher: modelMatcher
    });
    function modelMatcher (params, data) {

        var original_matcher = $.fn.select2.defaults.defaults.matcher;
        var result = original_matcher(params, data);
        if (result && data.children && result.children && data.children.length != result.children.length && data.text.toLowerCase().includes(params.term.toLowerCase()) ) {
            result.children = data.children;
        }
        return result;

        /*
        data.parentText = data.parentText || "";
        // Always return the object if there is nothing to compare
        if ($.trim(params.term) === '') {
            return data;
        }
        // Do a recursive check for options with children
        if (data.children && data.children.length > 0) {
            // Clone the data object if there are children
            // This is required as we modify the object to remove any non-matches
            var match = $.extend(true, {}, data);
            // Check each child of the option
            for (var c = data.children.length - 1; c >= 0; c--) {
                var child = data.children[c];
                child.parentText += data.parentText + " " + data.text;

                var matches = modelMatcher(params, child);

                // If there wasn't a match, remove the object in the array
                if (matches == null) {
                    match.children.splice(c, 1);
                }
            }
            // If any children matched, return the new object
            if (match.children.length > 0) {
                return match;
            }
            // If there were no matching children, check just the plain object
            return modelMatcher(params, match);
        }
        // If the typed-in term matches the text of this term, or the text from any
        // parent term, then it's a match.
        var original = (data.parentText + ' ' + data.text).toUpperCase();
        var term = params.term.toUpperCase();
        // Check if the text contains the term
        if (original.indexOf(term) > -1) {
            return data;
        }
        // If it doesn't contain the term, don't return anything
        return null;
        */
    }

    $('a.nav-card').on('click', function (e) {
        var target = $(this).attr('href');
        $('#pills-tab li a').removeClass('active');
        $('#pills-tab li a[href="' + target + '"]').addClass('active');
    });

    // read hash from page load and change tab
    var hash = document.location.hash;
    var prefix = "tab_";
    if (hash) {
        console.log(hash);
        $('.nav-tabs a[href="'+hash.replace(prefix,"")+'"]').tab('show');
        setTimeout(function() {$(window).scrollTop(0);}, 5);
    }

    $('.menu-toggle').click(function(e) {
        e.preventDefault();
        toggleMenu();
    });

    $('ul.nav > .haschildren > a').click(function(e) {
        e.preventDefault();
        $(this).parent().toggleClass('active');
    });

    // $('#toggleMenu').on('change', function(e) {
    //     toggleMenu();
    // });

    $('.account-menu').click(function(e) {
        e.preventDefault();
        $('.account-menu-nav').fadeToggle( 300, 'linear' );
    });

    $('.mobile-account-menu').click(function(e) {
        e.preventDefault();
        $('.topright-menu').slideToggle( 300, 'linear' );
    });

    // ************************ FILTERS ************************
    //Toggle Filters
    $('#filter').click(function(e) {
        var currentform = $(this).closest('form').attr('id');
        $('#' + currentform + ' .filterbox').toggle();
        if($('#' + currentform + ' #clearfilter').hasClass('d-none')) $('#' + currentform + ' #clearfilter').removeClass('d-none'); else $('#' + currentform + ' #clearfilter').addClass('d-none');
    });
    $('#filter').click();
    //Clear Filters
    $('#clearfilter').click(function(e) {
        var currentform = $(this).closest('form').attr('id');
        $('#' + currentform + ' :input[type=text]').val('');
        $('#' + currentform + ' .select2').val(null);
        $('.form-actions').slideUp();
        $('.filterbox .select2').trigger('change');
        //performSearch(currentform);
    });
    //Live Filters
    $('.filterbox').keyup(delay(function(e) {
        var currentform = $(this).closest('form').attr('id');
        $('#' + currentform + ' #page').val(1);
        performSearch(currentform);
    }, 500));
    //Apply filters on dropdown and daterange changes
    $('.filterbox .select2').change(function(e) {
        var currentform = $(this).closest('form').attr('id');
        $('#' + currentform + ' #page').val(1);
        performSearch(currentform);
    });
    //Apply filters daterange changes
    $('.filterbox.daterange').change(function(e) {
        var currentform = $(this).closest('form').attr('id');
        $('#' + currentform + ' #page').val(1);
        performSearch(currentform);
    });
    $(document).on('click', '#pagination .page-link', function(e) {
        e.preventDefault();
        var href = $(this).attr('href');
        var page = href.split('page=')[1];
        var currentform = $(this).closest('form').attr('id');
        $('#' + currentform + ' #page').val(page);
        performSearch(currentform);
    });
    //Toggle order
    $('.orderby').click(function(e) {
        e.preventDefault();
        var $previousOrder = $('#orderby').val();
        var $newOrder = $(this).data('order');
        var $changedir = false;
        if($previousOrder == $newOrder) $changedir = true;
        $('#orderby').val($newOrder);
        if($previousOrder != $newOrder && $(this).hasClass('numeric')) {
            $('#orderdir').val('DESC');
        } else if($previousOrder != $newOrder) {
            $('#orderdir').val('ASC');
        } else {
            if ($changedir) {
                if ($('#orderdir').val() == 'ASC') $('#orderdir').val('DESC')
                else $('#orderdir').val('ASC');
            }
        }
        var currentform = $(this).closest('form').attr('id');
        //performSearch(currentform);
        $('#'+currentform).submit();
    });

    // ************************ SELECT RECORDS ************************
    //Selected Items checkbox change
    $(document).on('click', 'table .recordsselected', function() {
        var show_formactions = false;
        var input = $('#recordsselected');
        var target = $(this).data('target');
        if(target) input = $(target + ' input[name="recordsselected"]');
        input.val(null);
        var selectedRecordsArray = [];
        var table = $(this).parent().parent().parent().parent();
        $('.recordsselected').each(function() {
            if($(this).prop('checked') == true) {
                selectedRecordsArray.push($(this).data('id'));
                input.val(JSON.stringify(selectedRecordsArray));
                show_formactions = true;
            } else {
                $('#checkbox-all').prop('checked', false);
                $('#exportall').val(0);
            }
        });
        if(show_formactions) {
            $('.form-actions').slideDown();
            $(target).prev().slideDown();
            //$('#checkbox-all').prop('checked', true);
        } else {
            $('.form-actions').slideUp();
            $(target).prev().slideUp();
            //$('#checkbox-all').prop('checked', false);
        }
    });
    //Select All checkbox change
    $('#checkbox-all').change(function() {
        var input = $('#recordsselected');
        var data_target = $(this).data('target');
        if(data_target) input = $(data_target + ' input[name="recordsselected"]');
        var checkbox = $('.recordsselected');
        var data_class = $(this).data('class');
        if(data_class) checkbox = $(data_class);
        if($(this).prop('checked') == true) {
            var selectedRecordsArray = [];
            checkbox.each(function() {
                $(this).prop('checked', true);
                selectedRecordsArray.push($(this).data('id'));
                input.val(JSON.stringify(selectedRecordsArray));
            });
            $('.form-actions').slideDown();
            $('#exportall').val(1);
        } else {
            checkbox.each(function() {
                $(this).prop('checked', false);
            });
            input.val(null);
            $('.form-actions').slideUp();
            $('#exportall').val(0);
        }
    });
    //Delete and Export functions
    $(document).on('click', '.modal-footer .deleterecords', function(e) {
        e.preventDefault();
        var target = $(this).data('target');
        if(target) {
            $(target).submit();
        } else {
            $('#recordsmassdelete').submit();
        }
    });

    // ************************ SELECT RECORDS MULTIPLE ON SAME PAGE ************************
    //Selected Items checkbox change
    $(document).on('click', '.tableSection table .recordsselectedm', function() {
        var tableSection = $(this).parent().parent().parent().parent().parent().parent();
        var show_formactions = false;
        var target = $(this).data('target');
        var input = $(target + ' input[name="recordsselected"]');
        input.val(null);
        var selectedRecordsArray = [];
        tableSection.find('.recordsselectedm').each(function() {
            if($(this).prop('checked') == true) {
                selectedRecordsArray.push($(this).data('id'));
                input.val(JSON.stringify(selectedRecordsArray));
                show_formactions = true;
            } else {
                tableSection.find('.checkbox-all').prop('checked', false);
            }
        });
        if(show_formactions) {
            tableSection.find('.form-actions').slideDown();
        } else {
            tableSection.find('.form-actions').slideUp();
        }
    });
    //Select All checkbox change
    $('.checkbox-all').change(function() {
        var tableSection = $(this).parent().parent().parent().parent().parent().parent();
        console.log(tableSection);
        var data_target = $(this).data('target');
        var input = $(data_target + ' input[name="recordsselected"]');
        var checkbox = tableSection.find('.recordsselectedm');
        var data_class = $(this).data('class');
        if(data_class) checkbox = $(data_class);
        if($(this).prop('checked') == true) {
            var selectedRecordsArray = [];
            checkbox.each(function() {
                $(this).prop('checked', true);
                selectedRecordsArray.push($(this).data('id'));
                input.val(JSON.stringify(selectedRecordsArray));
            });
            tableSection.find('.form-actions').slideDown();
        } else {
            checkbox.each(function() {
                $(this).prop('checked', false);
            });
            input.val(null);
            tableSection.find('.form-actions').slideUp();
        }
    });

    // ************************ FORMS ************************
    //Edit form functionality
    $('.editform').click(function(e) {
        e.preventDefault();
        $(this).addClass('d-none');
        $(this).parent().find('.canceleditform').removeClass('d-none');
        $(this).parent().find('.saveform').removeClass('d-none');
        var currentform = $(this).closest('form').attr('id');
        $('#' + currentform + ' :input').not('.alwaysdisabled').attr('disabled', false);
        $('#' + currentform + ' .btn-plus').removeClass('d-none');
        $('#' + currentform + ' .btn-minus').removeClass('d-none');
    });
    //Cancel Edit form functionality
    $('.canceleditform').click(function(e) {
        e.preventDefault();
        $(this).addClass('d-none');
        $(this).parent().find('.saveform').addClass('d-none');
        $(this).parent().find('.editform').removeClass('d-none');
        var currentform = $(this).closest('form').attr('id');
        $('#' + currentform + ' :input').not('.alwaysdisabled').attr('disabled', true);
        $('#' + currentform + ' .btn-plus').addClass('d-none');
        $('#' + currentform + ' .btn-minus').addClass('d-none');
    });
    //Save form functionality
    $('.saveform').click(function(e) {
        e.preventDefault();
        var currentform = $(this).closest('form').attr('id');
        var formisvalid = $('#' + currentform).valid();
        if(formisvalid) {
            $(this).addClass('d-none');
            $(this).parent().find('.canceleditform').addClass('d-none');
            $(this).parent().find('.editform').removeClass('d-none');
            var data = $('#' + currentform).serialize();
            $.ajax({
                url: $('#' + currentform).attr('action'),
                type: 'PUT',
                headers: {
                    'X-CSRF-TOKEN' : '{{ csrf_token() }}'
                },
                data: data
            }).done(function(responsedata) {
                $('#' + currentform + ' :input').not('.alwaysdisabled').attr('disabled', true);
                if(data.indexOf('refresh=true') != -1 || data.indexOf('refresh=1') != -1) {
                    //location.reload();
                    var href = new URL($(location).attr('href'));
                    href.hash = ($('#' + currentform).data('tab') ? $('#' + currentform).data('tab') : '');
                    window.location.replace(href.href);
                    location.reload();
                }
            }).fail(function(data, textStatus, xhr) {
                $('#modalGeneralError #modalGeneralErrorContent').html(data.responseJSON.response);
                $('#modalGeneralError').modal('show');
            });
        }
    });
    $('.input-group-text.link').click(function(e) {
        var url = $(this).closest('.form-group').find('input').val();
        if(url != null && url != '') {
            if(url.indexOf('http') == -1) {
                url = 'https://' + url;
            }
            if(validURL(url)) {
                var win = window.open(url, '_blank');
                win.focus();
            }
        }
    });
    $('.input-group-text.internallink').click(function(e) {
        var url = $(this).data('link');
        if(url != null && url != '') {
            if(url.indexOf('http') == -1) {
                url = 'https://' + url;
            }
            if(validURL(url)) {
                var win = window.open(url, '_blank');
                win.focus();
            }
        }
    });
    $('.input-group-text.submit').click(function(e) {
        $(this).closest('form')[0].submit();
    });
    $('.btn-reset').click(function(e) {
        $(this).closest('form')[0].reset();
        $(this).closest('form').find('input[type="checkbox"]').prop('checked', false);
        $(this).closest('form').find('input[type="number"]').val('');
        performSearch($(this).closest('form'));
    });

});